// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../types';
import { configSelector } from '../../../../selectors/configSelectors';
import Config from '../Config';
import type { Props } from '../Config';

const mapStateToProps = (state: State) => {
    return {
        config: configSelector(state)
    };
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(Config);